import DodonesShow from 'app/dodones/Show.jsx'

const DaysCurrent = () => {
  return <DodonesShow dodoneId="today" />
}

export default DaysCurrent
